module.exports = __webpack_public_path__ + "static/media/_cardano.df5466a6.svg";